import { useTranslation } from 'libs/i18n'
import { HistoryTable } from 'shared/components'
import { Header } from 'shared/components'
import { useFetchUserHistory } from './queries/useFetchUserHistory'

const UserHistoryPage = () => {
	const { t } = useTranslation()
	const { userHistory, isUserHistoryLoading } = useFetchUserHistory()

	return (
		<>
			<Header title={t('User / History')} />
			<HistoryTable results={userHistory?.data} isLoading={isUserHistoryLoading} />
		</>
	)
}

export default UserHistoryPage
